import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as Logo } from "../../svg/dota2.svg";

const LogoMemo = React.memo(Logo);

function Header() {
  const history = useHistory();

  const logoClickHandler = useCallback(() => {
      history.push("/main");
  }, [history])


  return (
    <header className="header">
      <div className="header_main">
        <div
          className="header_logo"
          onClick={ logoClickHandler }
        >
          <LogoMemo className="header_logo_icon" />
          <span className="header_logo_text">ggs bot</span>
        </div>
      </div>
    </header>
  );
}

export default Header;
